module.exports = __webpack_public_path__ + "static/media/app-icon-blue.bbe6c66a.svg";